import { HttpErrorResponse } from '@angular/common/http';
import { Component, inject, ChangeDetectionStrategy, signal, input, output } from '@angular/core';
import {StringUtils} from '../../utils/string-utils';
import {Entity} from '../../entity/entity';
import {OrderService} from '../../services/order-service';
import {ReleaseLine} from './release-line';
import { FormsModule } from '@angular/forms';
import { MatIcon } from '@angular/material/icon';
import { MatButton } from '@angular/material/button';
import { MatProgressSpinner } from '@angular/material/progress-spinner';


@Component({
    selector: 'line-release',
    templateUrl: './line-release.component.html',
    styleUrls: ['./line-release.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatProgressSpinner, MatButton, MatIcon, FormsModule]
})
export class LineReleaseComponent {
  private readonly orderService = inject(OrderService);


  readonly releaseLines = input.required<ReleaseLine[]>();
  readonly releaseGenerated = output<Entity>();
  readonly isBusy = signal<boolean>(undefined!);
  readonly errorMessage = signal<string>(undefined!);
  public totalQuantity: number = 0;

  private handleError(error: HttpErrorResponse): void {
    this.isBusy.set(false);
    this.errorMessage.set(StringUtils.getErrorMessage(error));
  }

  private resetStatus(): void {
    this.isBusy.set(true);
    this.errorMessage.set(undefined!);
  }

  updateQuantity(line: ReleaseLine): void {
    line.quantityToRelease = isNaN(line.quantityToRelease) || line.quantityToRelease <= 0 ? 0 : Math.floor(line.quantityToRelease);
    if (line.quantityToRelease > line.availableQuantity) {
      line.quantityToRelease = line.availableQuantity;
    }
    this.totalQuantity = this.getTotalQuantity();
  }

  private getTotalQuantity(): number {
    return this.releaseLines().map(line => line.quantityToRelease).reduce((accumulator, currentValue) => accumulator + currentValue);
  }

  generateRelease(): void {
    this.resetStatus();
    let selectedLines: ReleaseLine[] = this.releaseLines().filter(line => line.quantityToRelease > 0);
    if (selectedLines.length === 0) {
      this.errorMessage.set("No lines were selected to release");
      this.isBusy.set(false);
    } else {
      this.orderService.releaseByLine(selectedLines).subscribe(result => {
        this.releaseGenerated.emit(result);
      }, error => this.handleError(error));
    }
  }

}
